import React, { lazy, Suspense } from 'react';

const extensionUis = {
  'twilio-sms': lazy(() => import('./twilio-sms'))
};

export const loadExtensionUi = (extensionName) => {
  return extensionUis[extensionName] || null;
};

export const ExtensionUiLoader = ({ extensionName, component = 'settingsComponent', ...props }) => {
  const Component = loadExtensionUi(extensionName);
  if (!Component) return <p className="text-sm text-gray-500">No UI available for {extensionName}.</p>;

  return (
    <Suspense fallback={<p className="text-sm text-gray-500">Loading extension UI…</p>}>
      <Component {...props} />
    </Suspense>
  );
};

export default extensionUis;
